import type { FC } from 'react';
import PoweredByAvalanche from '@components/web3/PoweredByAvalanche';

const LandingFooter: FC = ({ children }) => {
  return (
    <div className="flex flex-col items-center text-center mt-4">
      {children}

      <PoweredByAvalanche inline={false} className="mt-12" />
    </div>
  );
};

export default LandingFooter;
